<template>
  <div id="app">
    <div class="area-radar-chart">
      <div class="content-1" style="height: 300px;padding: 0;">
        <!-- <div class="chart-content-div-header">
          <h4><small>{{ title }}</small></h4>
        </div> -->

        <div class="chart-content-div">
          <highcharts :options="chartOptions" ref='chart' style='height: 100%;width: 100%;'></highcharts>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Vue from 'vue'

export default {
  name: 'donut',
  data () {
    return {
      tableData: [],
      chartOptions: {
        chart: {
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
          },
          plotBorderColor: '#606063',
          // margin: -5,
          // marginTop: 20
        },
        title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          margin: -10,
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px !important',
            fontWeight: 'bold !important',
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          // pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.percentage:.2f}%</b>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>',
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            size: '80%',
            depth: 65,
            borderWidth: 0,
            dataLabels: {
              distance: 1
            },
            // startAngle: -180,
            // endAngle: 180,
            // center: ['50%', '50%'],
            cursor: 'pointer',
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              format: '<span style="color: #fff">{point.name}: {point.percentage:.1f}%</span>',
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            events:{
              click: this.loadGrid
            },
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px;'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#000'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        // scroll charts
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [
          {
            name: this.$t("302"),
            colorByPoint: true,
            data: [
              // nao alterar ordem, dentro do prazo=0, atrasado=1
              {name: this.$t("303"), y: this.data[0], color: '#90ed7d'},
              {name: this.$t("304"), y: this.data[1], color: '#f45b5b'}
            ]
          }
        ],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },
      },
    }
  },
  methods: {
    loadGrid(event){
      
      let planta = this.filters.plant; 
      let region = this.filters.region;

      let feedback = event.point.name;

      let delay;
      if(event.point.x == 0){
        delay = 0;
      } else if(event.point.x == 1){
        delay = 4; // todas rdp concluidas com atraso
      }

      let NAME_CHART = `${feedback.toUpperCase()} REPORTS`;

      const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?year=${this.filters.year}&period=${this.filters.period}&plant=${planta}&region=${region}&technique=${this.online ? '' : this.filters.technique}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&feedback_status=CLOSED&delay=${delay}&online=${this.online}`

      let grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
            "rows": '',
                "plant": this.$t("310"),
                "area": this.$t("311"),
                "sector": this.$t("312"),
                "component": this.$t("313"),
                "component_tag": this.$t("314"),
                "component_type_en": this.$t("315"),
                "machine": this.$t("316"),
                "machine_tag": this.$t("317"),
                "status_txt_en": this.$t("318"), 
                "report_number": this.$t("319"), 
                "approved_datetime": this.$t("320"),
                "technique_en": this.$t("321"),
                "ref_date": this.$t("322"), 
                "delay": this.$t("326"), 
                "feedback_status_en" : this.$t("333"), 
                "link": this.$t("323"),
                "link_rci": this.$t("324"),
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("356"),
        txtHelp: this.$t("357") 
      }

      if (this.filters.plant) {
        delete grid.columns['plant']
        grid.title += ' - ' + this.filters.plant_name;
      } else if (this.filters.region) {
        grid.title += ' - ' + this.filters.region;
      } else {
        grid.title += ' - GLOBAL';
      }

      this.changeGrid(grid);

    },
    ...mapMutations(['changeGrid']),
  },
  props: {
    title: {
      type: String
    },
    data: {
      type: Array
    },
    filters:{
      type: Object
    },
    online: {
      type: Number,
      default: 0
    }
  },
  watch: {
    data: function(value) {
      this.chartOptions.series[0].data[0].y = value[0];
      this.chartOptions.series[0].data[1].y = value[1];
    },
  }
}
</script>
<style scoped>
tspan {
  stroke: none!important;
  stroke-width: 1px;
  stroke-linejoin: round;
  /* font-size: 23px !important; */
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}
div[data-popover="helpresult"] {
  left: 85% !important;
}

.content-1 {
  border-radius: 0;
  color: #5b5b5b;
  min-height: 30px;
}

.chart-content-div{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.chart-content-div-header {
  /* padding: 0 0 0 15px; */
  text-align: center;
}

.chart-content-div-header h4{
  margin-top: -4px;
}

.chart-content-div-header h4 small{
  color: #ffffff;
}
.my-export{
  padding-right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/DonutExecution.vue